<template>
    <div v-bind:class="app_container_class" id="app-container">
        <div class="container-fluid full-height d-flex">
            <div class="col-12 full-height d-flex" id="payment-component-container">
                <transition name="content-fade">
                    <div class="d-flex full-height w-100 flex-column">
                        <div class="row flex-grow-1"></div>
                        <div class="row justify-content-center pb-170">
                            <div class="big-title-underline w-80">{{this.trans.get('kiosk.thank-you')}}</div>
                        </div>
                        <div class="row justify-content-center pb-4">
                            <div class="big-title w-80">{{this.trans.get('kiosk.receipt')}}</div>
                        </div>
                        <div class="row justify-content-center pb-5">
                            <div class="code-qr d-flex flex-column align-items-center w-25">
                                (code qr)
                            </div>
                        </div>
                        <div class="row justify-content-center pb-5">
                            <div class="icon-arrow-animated d-flex flex-column align-items-center w-25">
                                <object data="/assets/kiosk/img/arrow-borne.svg"></object>
                            </div>
                        </div>

                        <div class="row paiement-bottom">
                            <div>
                                {{this.trans.get('kiosk.back-to-home-in')}} <span v-text="time_remaining"></span>
                            </div>
                            <div class="mt-4">
                                <button @click="home" type="button" class="btn-light-blue text-uppercase">
                                    {{ this.trans.get('kiosk.return-now') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>

</template>

<script>
import {callAPI} from "../../helpers/kiosk-helpers";

export default {
    name: "PaymentCompleted",

    data(){
        return{
            app_container_class: 'd-flex p-0 m-0 bg-phoenix-paiement',
            time_remaining: 20,
            interVale: null,

        }
    },
    created() {
        this.$root.global_cancel_btn_disabled = false;

        this.create_invoice_custom();
    },


    methods: {
        back(){
            this.$root.cancel();
        },
        recalculateTimeRemaining()
        {
            if(this.interVale !== null) {
                this.time_remaining--;


                if (this.time_remaining <= 0) {
                    this.$root.invoice_loaded = false;
                    clearInterval(this.interVale);
                    this.$root.cancel_time();
                    this.$router.push({ name: this.$root.locale + '.home' });
                    //this.$root.cancel();
                }
            }
        },
        home()
        {
            this.$root.invoice_loaded = false;
            clearInterval(this.interVale);
            this.$root.cancel_time();
            this.$router.push({ name: this.$root.locale + '.home' });
            //this.$root.cancel();
        },
        create_invoice()
        {


            return new window.Promise((resolve, reject) => {
                callAPI(route('api.kiosk.get.order'),{ order_id: this.$root.order_id }, 'post')
                    .then(response => {

                        if(response['data']['success'] === 1)
                        {
                            this.invoice = response['data']['order'];

                            this.get_ticket()
                                .then(response => {
                                    this.$root.order_id = null;
                                    this.$root.invoice_loaded = true;
                                    this.interVale = setInterval(() => {
                                        this.recalculateTimeRemaining();
                                    }, 1000);
                                    resolve(response);
                                })
                                .catch(error => {
                                    this.$root.addErrors('a-301',null,String(error));
                                    reject(error);
                                });

                            resolve(response);
                        }
                        else {
                            this.$root.addErrors('a-301-2',null,'Response fail');
                            this.return_error = true;
                        }

                    })
                    .catch(error => {
                        this.$root.addErrors('a-301-3',null,String(error));
                        reject(error);
                    });
            });


        },

        create_invoice_custom()
        {


            return new window.Promise((resolve, reject) => {
                callAPI(route('api.kiosk.get.order.hockey'),{ order_id: this.$root.order_id }, 'post')
                    .then(response => {

                        if(response['data']['success'] === 1)
                        {
                            this.$root.invoice = response['data']['order'];
                            this.$root.previous_order.push(this.$root.invoice);


                            this.$root.order_id = null;
                            this.$root.invoice_loaded = true;

                            this.interVale = setInterval(() => {
                                this.recalculateTimeRemaining();
                            }, 1000);
                            resolve(response);

                        }
                        else {
                            this.$root.addErrors('a-302',null,'Response fail');
                            this.return_error = true;
                        }

                    })
                    .catch(error => {
                        this.$root.addErrors('a-302-2',null,String(error));
                        reject(error);
                    });
            });


        },


        get_ticket()
        {

                return new window.Promise((resolve, reject) => {
                    let nb = Object.entries(this.invoice['data']['cart_items']).length * 2;
                    let start = 0;


                    for (const [key, value] of Object.entries(this.invoice['data']['cart_items'])) {
                        callAPI(route('api.kiosk.get.ticket'), {
                            order_id: this.$root.order_id,
                            cart_item_idx: value['data']['idx']
                        }, 'post')
                            .then(response => {
                                if (response['data']['success'] === 1) {
                                    this.invoice['data']['cart_items'][key]['qr_code'] = response['data']['ticket']['data']['standard_information']['x8e_url'];

                                    start++;

                                    if(start === nb)
                                    {
                                        resolve('ok');
                                    }
                                } else {
                                    this.return_error = true;
                                    start++;
                                    if(start === nb)
                                    {
                                        resolve('ok');
                                    }
                                }

                            })
                            .catch(error => {
                                this.$root.addErrors('a-197',null,String(error));
                                reject(error);
                            });
                        //seating_chart_element_position_section
                        callAPI(route('api.kiosk.get.seat'), {
                            concretized_availabilities_uid: value['data']['product']['data']['features']['FEATURE_AVAILABILITY_POOLS_CONCRETIZED_AVAILABILITY_UIDS'][0],
                            order_id: this.$root.order_id
                        }, 'post')
                            .then(response => {
                                if (response['data']['success'] === 1) {
                                    this.invoice['data']['cart_items'][key]['seat'] = response['data']['seat']['data']['seating_chart_elements_section_position'][0];

                                    start++;

                                    if(start === nb)
                                    {
                                        resolve('ok');
                                    }
                                } else {
                                    this.return_error = true;
                                    start++;
                                    if(start === nb)
                                    {
                                        resolve('ok');
                                    }
                                }

                            })
                            .catch(error => {
                                this.$root.addErrors('a-196',null,String(error));
                                reject(error);
                            });
                    }


                });

        },
    },
}
</script>

<style scoped>

</style>
